import { type ReactNode } from 'react'

import { ErrorState } from './ErrorState'
import { LoadingState } from './LoadingState'

interface ReportDataWrapperProps {
  isLoading: boolean
  error: Error | unknown
  loadingMessage: string
  onRetry: () => void
  children: ReactNode
}

const ReportDataWrapper = ({
  isLoading,
  error,
  loadingMessage,
  onRetry,
  children,
}: ReportDataWrapperProps) => {
  return (
    <>
      {children}
      {isLoading && <LoadingState message={loadingMessage} />}
      {!isLoading && error && (
        <ErrorState
          error={error instanceof Error ? error : 'Unknown error'}
          onRetry={onRetry}
        />
      )}
    </>
  )
}

export { ReportDataWrapper }
